
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"800","height":"800","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17 7.83l1.697 1.526c1.542 1.389 2.313 2.083 2.313 2.974 0 .89-.771 1.585-2.314 2.973L17 16.83","stroke":"#1C274C","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"opacity":".5","d":"M13.987 5l-3.974 14.83","stroke":"#1C274C","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M7 7.83L5.304 9.356C3.76 10.745 2.99 11.44 2.99 12.33c0 .89.771 1.585 2.314 2.973L7 16.83","stroke":"#1C274C","stroke-width":"1.5","stroke-linecap":"round"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      